import { render } from "./details_product.vue?vue&type=template&id=fb6d4ab6"
import script from "./details_product.vue?vue&type=script&lang=js"
export * from "./details_product.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__